import {initWebComponent} from "@/helpers/web-component-helper";
import {Modal} from "bootstrap"
import {getBySelector} from "@/helpers/element-helper";
import { saveAs } from 'file-saver';

let modal

export class ImageModelComponent extends HTMLElement{
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<div class="modal fade" id="mdlImageModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Bestand</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <img class="w-100 cursor-pointer" id="imgImageModel">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Verbergen</button>
      </div>
    </div>
  </div>
</div>`;

        initWebComponent(this, template)

        modal = new Modal(document.getElementById('mdlImageModel'), {
            keyboard: false
        })
    }
}

export function showImageModal(imgSrc) {

    // console.log(imgSrc)

    getBySelector('#imgImageModel').src = imgSrc

    modal.show()
}
